import { InterfaceDef } from './checkSchema'

export const ISchemaProps_Def: InterfaceDef = {
    interface: 'ISchemaProps',
    extends: [],
    props: [
        { key: 'onInitSchema', type: 'IComponentFunction' },
        { key: 'onMount', type: 'IComponentFunction' },
        { key: 'onUnMount', type: 'IComponentFunction' },
        { key: 'validate', type: 'IValidateFunction' },
        { key: 'onSubmit', type: 'IComponentFunction' },
        { key: 'onReset', type: 'IComponentFunction' },
        { key: 'onMakeVisible', type: 'IComponentBoolFunction' },
        { key: 'tooltipComp', type: 'any' },
        { key: 'tooltipProps', type: 'any' },
    ]
}

export const ICommonProps_Def: InterfaceDef = {
    interface: 'ICommonProps',
    extends: ['IStyles', 'IEventOptions'],
    props: [
        { key: 'name', type: 'string' },
        { key: 'hidden', type: 'any' },
        { key: 'disabled', type: 'any' },
        { key: 'themeColor', type: '| gray | red | yellow | green | blue | indigo | purple | pink' },
        { key: 'tooltip', type: 'string' },
        { key: 'cols', type: 'xs1&xs2&xs3&xs4&xs5&xs6&xs7&xs8&xs9&xs10&xs11&xs12&sm1&sm2&sm3&sm4&sm5&sm6&sm7&sm8&sm9&sm10&sm11&sm12&md1&md2&md3&md4&md5&md6&md7&md8&md9&md10&md11&md12&lg1&lg2&lg3&lg4&lg5&lg6&lg7&lg8&lg9&lg10&lg11&lg12&xl1&xl2&xl3&xl4&xl5&xl6&xl7&xl8&xl9&xl10&xl11&xl12&xx1&xx2&xx3&xx4&xx5&xx6&xx7&xx8&xx9&xx10&xx11&xx12' },
        { key: 'parentComp', type: 'IComponent' },
        { key: 'addProps', type: 'any' },
        { key: 'tag', type: 'any' },
    ]
}

export const IStyles_Def: InterfaceDef = {
    interface: 'IStyles',
    extends: [],
    props: [
        { key: 'style', type: 'React.CSSProperties' },
        { key: 'className', type: 'string' },
        { key: 'classes', type: 'IClasses' },
    ]
}

export const IEventOptions_Def: InterfaceDef = {
    interface: 'IEventOptions',
    extends: [],
    props: [
        { key: 'onChange', type: 'IComponentFunction' },
        { key: 'onClick', type: 'IComponentFunction' },
        { key: 'onDoubleClick', type: 'IComponentFunction' },
        { key: 'onMouseDown', type: 'IComponentFunction' },
        { key: 'onMouseEnter', type: 'IComponentFunction' },
        { key: 'onMouseLeave', type: 'IComponentFunction' },
        { key: 'onMouseMove', type: 'IComponentFunction' },
        { key: 'onKeyDown', type: 'IComponentFunction' },
        { key: 'onKeyPress', type: 'IComponentFunction' },
        { key: 'onKeyUp', type: 'IComponentFunction' },
        { key: 'onFocus', type: 'IComponentFunction' },
        { key: 'onBlur', type: 'IComponentFunction' },
        { key: 'onSelect', type: 'IComponentFunction' },
        { key: 'onScroll', type: 'IComponentFunction' },
        { key: 'onWheel', type: 'IComponentFunction' },
    ]
}

export const IContainerComponent_Def: InterfaceDef = {
    interface: 'IContainerComponent',
    extends: ['ICommonProps'],
    props: [
        { key: 'children', type: 'IComponent[]', required: true },
        { key: 'usesGrid', type: 'boolean' },
    ]
}

export const IDataComponent_Def: InterfaceDef = {
    interface: 'IDataComponent',
    extends: ['ICommonProps'],
    props: [
        { key: 'field', type: 'string', required: true },
        { key: 'unbound', type: 'boolean' },
        { key: 'dataType', type: 'string | float | int | bool | date' },
        { key: 'default', type: 'any' },
        { key: 'required', type: 'boolean' },
        { key: 'validate', type: 'IValidateFunction' },
    ]
}

// Components
export const IPanelComponent_Def: InterfaceDef = {
    interface: 'IPanelComponent',
    extends: ['IContainerComponent'],
    props: [
        { key: 'type', type: 'panel', required: true },
    ]
}

export const IFormComponent_Def: InterfaceDef = {
    interface: 'IFormComponent',
    extends: ['IContainerComponent'],
    props: [
        { key: 'type', type: 'form', required: true },
    ]
}

export const ICardComponent_Def: InterfaceDef = {
    interface: 'ICardComponent',
    extends: ['IContainerComponent'],
    props: [
        { key: 'type', type: 'card', required: true },
        { key: 'label', type: 'string' },
        { key: 'headerComponent', type: 'IComponent' },
        { key: 'styleHeader', type: 'IStyles' },
        { key: 'styleLabel', type: 'IStyles' },
        { key: 'styleChildren', type: 'IStyles' },
    ]
}

export const IExpansionspanelComponent_Def: InterfaceDef = {
    interface: 'IExpansionspanelComponent',
    extends: ['IContainerComponent'],
    props: [
        { key: 'type', type: 'expansionspanel', required: true },
        { key: 'label', type: 'string' },
        { key: 'expanded', type: 'boolean' },
        { key: 'headerComponent', type: 'IComponent' },
        { key: 'styleHeader', type: 'IStyles' },
        { key: 'styleLabel', type: 'IStyles' },
        { key: 'styleIcon', type: 'IStyles' },
        { key: 'styleChildren', type: 'IStyles' },
    ]
}


export const ITabsComponent_Def: InterfaceDef = {
    interface: 'ITabsComponent',
    extends: ['IContainerComponent'],
    props: [
        { key: 'type', type: 'tabs', required: true },
        { key: 'selectedTabIndex', type: 'number' },
        { key: 'styleHeader', type: 'IStyles' },
        { key: 'styleLabel', type: 'IStyles' },
        { key: 'styleIcon', type: 'IStyles' },
        { key: 'styleChildren', type: 'IStyles' },
    ]
}

export const ITabComponent_Def: InterfaceDef = {
    interface: 'ITabComponent',
    extends: ['IContainerComponent'],
    props: [
        { key: 'type', type: 'tab', required: true },
        { key: 'label', type: 'string', required: true },
        { key: 'iconComp', type: 'any' },
    ]
}

export const IModalComponent_Def: InterfaceDef = {
    interface: 'IModalComponent',
    extends: ['IContainerComponent'],
    props: [
        { key: 'type', type: 'modal', required: true },
        { key: 'name', type: 'string', required: true },
        { key: 'label', type: 'string' },
        { key: 'headerComponent', type: 'IComponent' },
        { key: 'styleDialog', type: 'IStyles' },
        { key: 'styleHeader', type: 'IStyles' },
        { key: 'styleLabel', type: 'IStyles' },
        { key: 'styleChildren', type: 'IStyles' },
    ]
}

export const IDataTableComponent_Def: InterfaceDef = {
    interface: 'IDataTableComponent',
    extends: ['IDataComponent'],
    props: [
        { key: 'type', type: 'datatable', required: true },
        { key: 'cardView', type: 'boolean' },
        { key: 'detailComponent', type: 'IComponent', required: true },
        { key: 'summaryCard', type: 'ISummaryFunction' },
        { key: 'summaryCellTitle', type: 'ISummaryFunction' },
        { key: 'summaryCellValue', type: 'ISummaryFunction' },
        { key: 'label', type: 'string' },
        { key: 'options', type: 'IDataTableOptions' },
        { key: 'styleLabel', type: 'IStyles' },
        { key: 'styleHeader', type: 'IStyles' },
        { key: 'styleCardContent', type: 'IStyles' },
        { key: 'styleTableContent', type: 'IStyles' },
        { key: 'styleTable', type: 'IStyles' },
        { key: 'styleTableHead', type: 'IStyles' },
        { key: 'styleTableHeadRow', type: 'IStyles' },
        { key: 'styleTableHeadCell', type: 'IStyles' },
        { key: 'styleTableBody', type: 'IStyles' },
        { key: 'styleTableRow', type: 'IStyles' },
        { key: 'styleTableRowEven', type: 'IStyles' },
        { key: 'styleTableRowOdd', type: 'IStyles' },
        { key: 'styleCard', type: 'IStyles' },
        { key: 'styleCardEven', type: 'IStyles' },
        { key: 'styleCardOdd', type: 'IStyles' },
        { key: 'styleTableCell', type: 'IStyles' },
        { key: 'selectedRowIndex', type: 'number' },
        { key: 'editRowIndex', type: 'number' },
    ]
}

export const IToolbarComponent_Def: InterfaceDef = {
    interface: 'IToolbarComponent',
    extends: ['IContainerComponent'],
    props: [
        { key: 'type', type: 'toolbar', required: true },
        { key: 'label', type: 'string' },
        { key: 'styleLabel', type: 'IStyles' },
        { key: 'styleChildren', type: 'IStyles' },

    ]
}

export const IFieldComponent_Def: InterfaceDef = {
    interface: 'IFieldComponent',
    extends: ['ICommonProps'],
    props: [
        { key: 'type', type: 'field', required: true },
        { key: 'inputComponent', type: 'IComponent', required: true },
        { key: 'label', type: 'string', required: true },
        { key: 'hint', type: 'string' },
        { key: 'styleLabel', type: 'IStyles' },
        { key: 'styleErrorLabel', type: 'IStyles' },
        { key: 'styleHint', type: 'IStyles' },
    ]
}

export const IInputComponent_Def: InterfaceDef = {
    interface: 'IInputComponent',
    extends: ['IDataComponent'],
    props: [
        { key: 'type', type: 'input', required: true },
        { key: 'multiline', type: 'boolean' },
        { key: 'multiselect', type: 'boolean' },
        { key: 'placeholder', type: 'string' },
        { key: 'styleInput', type: 'IStyles' },
        { key: 'styleError', type: 'IStyles' },
        { key: 'options', type: 'string[]' },
    ]
}

export const ISelectComponent_Def: InterfaceDef = {
    interface: 'ISelectComponent',
    extends: ['IDataComponent'],
    props: [
        { key: 'type', type: 'select', required: true },
        { key: 'options', type: 'string[] | ISelectOptionItem[]', required: true },
        { key: 'multiselect', type: 'boolean' },
        { key: 'placeholder', type: 'string' },
        { key: 'styleInput', type: 'IStyles' },
        { key: 'styleError', type: 'IStyles' },
        { key: 'styleOptions', type: 'IStyles' },
    ]
}

export const ICheckboxComponent_Def: InterfaceDef = {
    interface: 'ICheckboxComponent',
    extends: ['IDataComponent'],
    props: [
        { key: 'type', type: 'checkbox', required: true },
        { key: 'label', type: 'string' },
        { key: 'styleInput', type: 'IStyles' },
        { key: 'styleLabel', type: 'IStyles' },
    ]
}

export const IRadioGroupComponent_Def: InterfaceDef = {
    interface: 'IRadioGroupComponent',
    extends: ['IDataComponent'],
    props: [
        { key: 'type', type: 'radiogroup', required: true },
        { key: 'options', type: 'string[] | ISelectOptionItem[]', required: true },
        { key: 'styleInputGroup', type: 'IStyles' },
        { key: 'styleInput', type: 'IStyles' },
        { key: 'styleLabel', type: 'IStyles' },
    ]
}

export const ILabelComponent_Def: InterfaceDef = {
    interface: 'ILabelComponent',
    extends: ['ICommonProps'],
    props: [
        { key: 'type', type: 'label', required: true },
        { key: 'label', type: 'string', required: true },
    ]
}

export const IButtonComponent_Def: InterfaceDef = {
    interface: 'IButtonComponent',
    extends: ['ICommonProps'],
    props: [
        { key: 'type', type: 'button', required: true },
        { key: 'label', type: 'string' },
        { key: 'kind', type: '"" | standard | outline | pill | flat | icon | toolbar' },
        { key: 'buttonType', type: 'button | submit | reset' },
        { key: 'iconComp', type: 'any' },
        { key: 'styleLabel', type: 'IStyles' },
        { key: 'styleIcon', type: 'IStyles' },
    ]
}

export const ILinkComponent_Def: InterfaceDef = {
    interface: 'ILinkComponent',
    extends: ['IButtonComponent'],
    props: [
        { key: 'type', type: 'link', required: true },
        { key: 'href', type: 'string', required: true },
        { key: 'openInNewTab', type: 'boolean' },
    ]
}

export const IDividerComponent_Def: InterfaceDef = {
    interface: 'IDividerComponent',
    extends: ['ICommonProps'],
    props: [
        { key: 'type', type: 'divider', required: true },

    ]
}

export const IImageComponent_Def: InterfaceDef = {
    interface: 'IImageComponent',
    extends: ['ICommonProps'],
    props: [
        { key: 'type', type: 'image', required: true },
        { key: 'src', type: 'string', required: true },
        { key: 'width', type: 'string' },
        { key: 'height', type: 'string' },
        { key: 'alt', type: 'string' },
    ]
}

export const IHtmlComponent_Def: InterfaceDef = {
    interface: 'IHtmlComponent',
    extends: ['ICommonProps'],
    props: [
        { key: 'type', type: 'html', required: true },
        { key: 'html', type: 'string', required: true },
    ]
}

export const IIconComponent_Def: InterfaceDef = {
    interface: 'IIconComponent',
    extends: ['ICommonProps'],
    props: [
        { key: 'type', type: 'icon', required: true },
        { key: 'iconComp', type: 'any', required: true },
    ]
}

export const IErrorPanelComponent_Def: InterfaceDef = {
    interface: 'IErrorPanelComponent',
    extends: ['ICommonProps'],
    props: [
        { key: 'type', type: 'errorpanel', required: true },
        { key: 'label', type: 'string' },
    ]
}